import { createSlice } from '@reduxjs/toolkit'

export const selectedMarketSlice = createSlice({
  name: 'selectedMarket',
  initialState: {
    value: {
      id: 'btcusdt',
      name: 'BTC/USDT',
      base_unit: 'btc',
      quote_unit: 'usdt',
      min_price: '0.01',
      max_price: '100000',
      min_amount: '0.0001',
      amount_precision: 4,
      price_precision: 2
    }
  },
  reducers: {
    setSelectedMarket: (state, payload) => {
      state.value = payload.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setSelectedMarket } = selectedMarketSlice.actions

export default selectedMarketSlice.reducer